exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-styles[data-v-6f064622]{padding-top:20px}.chart-styles .c-s-t[data-v-6f064622]{font-size:14px;font-weight:bold;margin-bottom:5px}.chart-styles .question-icon[data-v-6f064622]{cursor:pointer;margin-left:5px;position:relative;top:3px}\n", ""]);

// exports
